export default "__VITE_ASSET__Cpbjm4Ob__"